import {atomWithReset} from 'jotai/utils'
import {IGameEndedMessage} from '../../../types/ws.types'

export const gameEndedState = atomWithReset<IGameEndedMessage | null>(null)
